import { SelectableBillingPeriodTypes } from '@constants/billingPeriods'
import { CurrenciesType } from '@constants/currencies'
import { PlanRecordKeyTypes } from '@constants/plans'
import { GetPackagesTypes, Tariff } from '@services/payments/useGetPackages'

export const getPackagePrice = ({
  packages,
  periodToFind,
  currencyToFind,
  packageRecordKey
}: {
  packages: GetPackagesTypes[]
  periodToFind: SelectableBillingPeriodTypes
  currencyToFind: CurrenciesType
  packageRecordKey: PlanRecordKeyTypes
}) => {
  const packagePrice = packages
    ?.find(({ record_key }) => record_key === packageRecordKey)
    ?.tariffs.find(({ period }: Tariff) => period === periodToFind)
    ?.pricing?.find(
      ({ currency }: { currency: CurrenciesType }) =>
        currency === currencyToFind
    )?.price

  return packagePrice ? Number((packagePrice / periodToFind).toFixed(2)) : 0
}
